import { useState } from 'react'
/* components */
import { Avatar, Box } from '@mui/material'

/* styles */
import useStyles from './useStyles'
/* redux */
/* users data role */
import ProfileModal from '../../ProfileModal/ProfileModal'

function ProfileMenuMobile () {
  const classes = useStyles()
  const [openProfileModal, setOpenProfileModal] = useState(false)
  const [anchorElement, setAnchorElement] = useState(null)

  /* Open the menu from the profile avatar */
  const handleProfileModalClose = () => {
    setOpenProfileModal(false)
  }

  const handleClickProfileModal = (event) => {
    setOpenProfileModal(true)
    setAnchorElement(event.currentTarget)
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.iconList}></Box>

      <Avatar onClick={handleClickProfileModal} className={classes.avatar} />

      <ProfileModal
        open={openProfileModal}
        onClose={handleProfileModalClose}
        anchorEl={anchorElement}
      />
    </Box>
  )
}

export default ProfileMenuMobile
